/*
 *  @Descripttion:
 * @version:
 * @Author: etong
 * @Date: 2020-08-04 10:06:42
 * @LastEditors: your name
 * @LastEditTime: 2023-09-15 19:35:53
 */
// 在所有其他导入之前引入 polyfills
import './polyfills'
import Vue from 'vue'
// umy-table 依赖 xe-utils/ctor，但部分能力（如 browse）需要先加载完整 xe-utils 以完成 mixin
import 'xe-utils'
// CDN兼容性检查 (Node.js 14兼容写法)
if (typeof window !== 'undefined') {
  // 确保CDN依赖正确加载
  const requiredGlobals = ['Vue', 'VueRouter', 'Vuex', 'ELEMENT', 'axios', '_', 'moment']
  const missing = requiredGlobals.filter(function(name) {
    return !window[name]
  })

  if (missing.length > 0) {
    console.warn('CDN依赖加载不完整，缺失:', missing.join(', '))
  }

  // 安装Vuex到Vue (CDN模式下需要手动安装)
  if (window.Vuex && !Vue._installedPlugins.some(function(p) { return p === window.Vuex })) {
    Vue.use(window.Vuex)
  }
}

import Cookies from 'js-cookie'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import Element from 'element-ui'
import './styles/element-variables.scss'
// import 'element-ui/lib/theme-chalk/index.css'

import '@/styles/index.scss' // global css

// 按需加载：
import 'vis-network/styles/vis-network.min.css'

import App from './App'
import router from './router'
import store from './store'

import './icons' // icon
import './permission' // permission control
// import './mock' // simulation data
import '@/components/JJForm' // 通用表单
import '@/components/CommonSearch' // 通用列表查询
import '@/components/JJVisNetwork' // 通用网络关系图
import '@/components/JJuxCommonTable' // 通用可编辑表格

// 使用moment.js
import moment from 'moment'

Vue.prototype.$moment = moment

import * as filters from './filters' // global filters
import Mixin from './mixins'
Vue.mixin(Mixin)
// 改为按需加载
import waterfall from 'vue-waterfall2'
Vue.use(waterfall)
import Print from 'vue-print-nb'
Vue.use(Print)
import smartParse from 'vue-smart-parse'
Vue.use(smartParse)
import preventReClick from '@/directive/preventReClick'
Vue.use(preventReClick)
import trim from '@/directive/trimEnterClick'
Vue.use(trim)

Vue.use(Element, {
  size: Cookies.get('size') || 'mini' // set element-ui default size
})

// 重型表格库改为按需加载
import {
  UTableColumn,
  UTable,
  UxGrid,
  UxTableColumn
} from 'umy-ui'
Vue.use(UTableColumn)
Vue.use(UTable)
Vue.use(UxGrid)
Vue.use(UxTableColumn)
Vue.prototype.$bus = new Vue()

import tag from './components/Tag'
Vue.use(tag)

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

import inputRule from './directive/input_rule'
Vue.use(inputRule)
// socket uri
import * as socketApi from './utils/socket'
Vue.prototype.socketApi = socketApi
import { message } from './utils/message'
Vue.prototype.$message = message

// 另一个表格库改为按需加载
import 'vue-easytable/libs/theme-default/index.css'
import { VeTable, VePagination, VeIcon, VeLoading, VeLocale } from 'vue-easytable'
Vue.use(VeTable)
Vue.use(VePagination)
Vue.use(VeIcon)
Vue.use(VeLoading)
Vue.prototype.$veLoading = VeLoading
Vue.prototype.$veLocale = VeLocale

// === 按需加载重型库的方法 ===
// Vue.prototype.$loadUmyTable = async function() {
//   if (!this._umyTableLoaded) {
//     const { UTableColumn, UTable, UxGrid, UxTableColumn } = await import('umy-ui')
//     Vue.use(UTableColumn)
//     Vue.use(UTable)
//     Vue.use(UxGrid)
//     Vue.use(UxTableColumn)
//     this._umyTableLoaded = true
//   }
// }

// Vue.prototype.$loadEasyTable = async function() {
//   if (!this._easyTableLoaded) {
//     await import('vue-easytable/libs/theme-default/index.css')
//     const { VeTable, VePagination, VeIcon, VeLoading, VeLocale } = await import('vue-easytable')
//     Vue.use(VeTable)
//     Vue.use(VePagination)
//     Vue.use(VeIcon)
//     Vue.use(VeLoading)
//     Vue.prototype.$veLoading = VeLoading
//     Vue.prototype.$veLocale = VeLocale
//     this._easyTableLoaded = true
//   }
// }

// Vue.prototype.$loadWaterfall = async function() {
//   if (!this._waterfallLoaded) {
//     const waterfall = await import('vue-waterfall2')
//     Vue.use(waterfall.default || waterfall)
//     this._waterfallLoaded = true
//   }
// }

// Vue.prototype.$loadPrint = async function() {
//   if (!this._printLoaded) {
//     const Print = await import('vue-print-nb')
//     Vue.use(Print.default || Print)
//     this._printLoaded = true
//   }
// }

// Vue.prototype.$loadSmartParse = async function() {
//   if (!this._smartParseLoaded) {
//     const smartParse = await import('vue-smart-parse')
//     Vue.use(smartParse.default || smartParse)
//     this._smartParseLoaded = true
//   }
// }

Vue.config.productionTip = false
Vue.config.devtools = true

import buttonEffect from '@/directive/buttonEffect'

Vue.directive('button-effect', buttonEffect)

import './directive/rainbowSparkle'

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
